var render, staticRenderFns
import script from "./rps.vue?vue&type=script&lang=js"
export * from "./rps.vue?vue&type=script&lang=js"
import style0 from "./rps.vue?vue&type=style&index=0&id=6ac0444f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports